import React from "react";
import { Link } from "react-router-dom";
function Header() {
  return (
    <div>
      {/* <!-- Topbar Start -->   style={{backgroundColor: '#040404 !important'} */}
 <div className="container-fluid bg-zdark px-5">
  <div className="row gx-4 d-none d-lg-flex">
    <div className="col-lg-8 text-start">
      <div className="h-100 d-inline-flex align-items-center py-3 me-4">
        <div className="btn-sm-square rounded-circle bg-primary me-2">
          <small className="fa fa-map-marker-alt text-white" />
        </div>
        <small>Ashok Nagar,Road No-7B,Kankarbagh,Near Ramdev Mandir, Patna</small>
      </div>
      <div className="h-100 d-inline-flex align-items-center py-3">
        <div className="btn-sm-square rounded-circle bg-primary me-2">
          <small className="fa fa-envelope-open text-white" />
        </div>
        <small>info@eagleeyeenterprises.co.in</small>
      </div>
    </div>
    <div className="col-lg-4 text-end">
      <div className="h-100 d-inline-flex align-items-center py-3 me-4">
        <div className="btn-sm-square rounded-circle bg-primary me-2">
          <small className="fa fa-phone-alt text-white" />
        </div>
        <small>+91 99999 00000</small>
      </div>
      <div className="h-100 d-inline-flex align-items-center py-3">
        <div className="btn-sm-square rounded-circle bg-primary me-2">
          <small className="far fa-clock text-white" />
        </div>
        <small>Mon - Sat : 9AM - 9PM</small>
      </div>
    </div>
  </div>
</div>


      {/* <!-- Topbar End --> */}

      {/* <!-- Navbar Start --> */}
 
   <nav className="navbar navbar-expand-lg bg-nav  navbar-light sticky-top p-0 px-4 px-lg-5">
   <Link to="/" className="navbar-brand d-flex align-items-center">
           
           <img
                       className="img-fluid"
                       src="assets/img/nnewLogo.png"
                       alt="Icon"
                     />
 
         </Link>   
     
           <button type="button" className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" style={{color:'#1f1e7d',backgroundColor:'#65b530'}}>
    <span className="navbar-toggler-icon" />
  </button>
  <div className="collapse navbar-collapse" id="navbarCollapse">
    <div className="navbar-nav ms-auto  py-4 py-lg-0">
    <Link to="" className="nav-item nav-link ">
              Home
            </Link>
            <Link to="/about" className="nav-item nav-link">
              About
            </Link>

            <Link to="/service" className="nav-item nav-link">
              Service
            </Link>
            
            <Link to="/contact" className="nav-item nav-link">
              Contact
            </Link>
                </div>
     
  </div>
</nav>


      {/* <!-- Navbar End --> */}
    </div>
  );
}

export default Header;
